import { render, staticRenderFns } from "./MalariaTestNumber.vue?vue&type=template&id=41f18606&scoped=true"
import script from "./MalariaTestNumber.vue?vue&type=script&lang=js"
export * from "./MalariaTestNumber.vue?vue&type=script&lang=js"
import style0 from "./MalariaTestNumber.vue?vue&type=style&index=0&id=41f18606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f18606",
  null
  
)

export default component.exports